module.exports = __webpack_public_path__ + "img/clients-active.20e65aba.svg";